export const STREETVIEW_MODE =
  process.env.REACT_APP_STREETVIEW_MODE || "external";

export const canOpenStreetViewModal = () => {
  return false;//STREETVIEW_MODE === "modal";
};

export const isStreetViewDisabled = () => {
  return STREETVIEW_MODE === "disabled";
};
